import {Route} from "vue-router";
import {saveScrolls} from "../helpers/scrollHelper";

const afterEach = (to: Route, from: Route) => {
    if (from.name) {
        saveScrolls(from.name.toString());
    }
}

export { afterEach }